"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlButton = exports.CloseControl = exports.HamburgerControl = exports.Control = exports.ControlsWrapper = exports.ContentWrapper = exports.StyledMenuMobile = exports.MobileMask = exports.MobileMenuWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// External
var MobileMenuWrapper = _styledComponents.default.div.withConfig({
  displayName: "MenuMobilestyles__MobileMenuWrapper",
  componentId: "x4l7pm-0"
})(["position:relative;"]);

exports.MobileMenuWrapper = MobileMenuWrapper;

var MobileMask = _styledComponents.default.div.withConfig({
  displayName: "MenuMobilestyles__MobileMask",
  componentId: "x4l7pm-1"
})(["display:", ";position:fixed;top:0;bottom:0;left:0;right:0;background-color:", ";"], function (props) {
  return props.isOpen ? 'block' : 'none';
}, function (props) {
  return props.theme.c_mask_modal;
});

exports.MobileMask = MobileMask;

var StyledMenuMobile = _styledComponents.default.div.withConfig({
  displayName: "MenuMobilestyles__StyledMenuMobile",
  componentId: "x4l7pm-2"
})(["align-items:center;background-color:", ";box-shadow:", ";display:flex;flex-direction:row;height:", ";justify-content:space-between;position:relative;width:100%;z-index:", ";"], function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.theme.s_menu;
}, function (props) {
  return props.theme.mobileMenuHeight;
}, function (props) {
  return props.theme.menu;
});

exports.StyledMenuMobile = StyledMenuMobile;

var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "MenuMobilestyles__ContentWrapper",
  componentId: "x4l7pm-3"
})(["display:flex;flex:1;justify-content:flex-start;padding-left:", ";"], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 3, props.theme.standardPadding);
});

exports.ContentWrapper = ContentWrapper;

var ControlsWrapper = _styledComponents.default.div.withConfig({
  displayName: "MenuMobilestyles__ControlsWrapper",
  componentId: "x4l7pm-4"
})(["display:block;flex-direction:column;height:3rem;overflow:hidden;position:relative;"]);

exports.ControlsWrapper = ControlsWrapper;

var Control = _styledComponents.default.div.withConfig({
  displayName: "MenuMobilestyles__Control",
  componentId: "x4l7pm-5"
})(["display:flex;flex-direction:row-reverse;position:relative;transition:.3s top,.3s opacity;transition-timing-function:ease-in-out;"]);

exports.Control = Control;
var HamburgerControl = (0, _styledComponents.default)(Control).withConfig({
  displayName: "MenuMobilestyles__HamburgerControl",
  componentId: "x4l7pm-6"
})(["", ";"], function (props) {
  return props.isOpen ? (0, _styledComponents.css)(["top:100%;opacity:0;"]) : (0, _styledComponents.css)(["top:-100%;opacity:1;"]);
});
exports.HamburgerControl = HamburgerControl;
var CloseControl = (0, _styledComponents.default)(Control).withConfig({
  displayName: "MenuMobilestyles__CloseControl",
  componentId: "x4l7pm-7"
})(["", ";"], function (props) {
  return props.isOpen ? (0, _styledComponents.css)(["top:0%;opacity:1;"]) : (0, _styledComponents.css)(["top:-100%;opacity:0;"]);
});
exports.CloseControl = CloseControl;

var ControlButton = _styledComponents.default.button.withConfig({
  displayName: "MenuMobilestyles__ControlButton",
  componentId: "x4l7pm-8"
})(["align-items:center;border:none;cursor:pointer;display:flex;flex-direction:column;font-weight:", ";outline:none;& span{font-size:.8rem;line-height:1.2;}& svg{font-size:2rem;}& path,& > span{color:", ";}&:active,&:hover{& > svg,& > span{color:", ";}}"], function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_text;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_hover_text;
});

exports.ControlButton = ControlButton;